/*-- import aliases -----------
'!/...' -> project root
'~/dfwjobs/...' -> js folder root
-----------------------------*/
import { setup } from "~/dfwjobs/core";
setup();

import "~/dfwjobs/global/_body";
import "~/dfwjobs/global/_header";
import "~/dfwjobs/global/_footer";
import "~/dfwjobs/global/_alert";
import "~/dfwjobs/global/_searchModal";

import "~/dfwjobs/components/_accordion";
import "~/dfwjobs/components/_forms";
import "~/dfwjobs/components/_heroHome";
import "~/dfwjobs/components/_carousel";
import "~/dfwjobs/components/_ctaUpdates";
import "~/dfwjobs/components/_faqs";
import "~/dfwjobs/components/_intNav";
import "~/dfwjobs/components/_video";
import "~/dfwjobs/components/_eventDetails";
import "~/dfwjobs/components/_modal";
